const runtimeConfig = (window as any).APP_CONFIG || {};

export const AppSettings = {
  apiBaseUrl: runtimeConfig?.apiBaseUrl || "https://localhost:3000/",
  defaultLanguage: runtimeConfig?.defaultLanguage || "sl",
  env: runtimeConfig?.env || "prod", // dev, test, prod
  languages: [
    {
      code: "sl",
      name: "Slovenščina",
    },
    {
      code: "en",
      name: "English",
    },
  ],
  tableItemsThreshold: 25,
  files: {
    maxAllowedSize: 50, // MB
    allowedTypes: [
      "application/pdf",
      "application/msword",
      "application/vnd.ms-excel",
      "image/jpeg",
      "image/png",
      "image/tiff",
      "",
    ], // MIME types
    supportedPreviewTypes: [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/gif"
    ]
  },
};
